(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-panel-content-tab-refresh-model', actionRefreshPanelContentTab);

    function actionRefreshPanelContentTab(PanelContentTabService, lodash) {
        return function(options) {
            var identifier = lodash.get(options, 'identifier', null);
            if (identifier !== null) {
                return PanelContentTabService.refreshModel(identifier);
            }
            // returning false. It is up to the person writing the actions to understand
            // that they shouldn't use this actions if they didn't set the async model for panel
            // content tab
            return false;
        }
    }
})();